import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import Col from "../../../../../components/Common/Col";
import Row from "../../../../../components/Common/Row";
import { formatBinaryCapacityUnit, formatDailyVolumeLimit } from "../../../../../utils/Format";
import OrderHelpers from "../../../../../utils/OrderHelpers";
import { OrderCostSummaryV2Props } from "../index";

const VolumeSummary = (props: OrderCostSummaryV2Props) => {
  const { cost, currentCostingVersion } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  const isOverLimit = OrderHelpers.isOverVolumeLimit(cost, currentCostingVersion);

  return (
    <Fragment>
      <Row className="highlighted">
        <Col sm={12} md={10}>
          Estimated daily volume

          {
            isOverLimit && currentCostingVersion &&
            <div className="data-limit-warning">
              <FontAwesomeIcon icon={faExclamationTriangle} className="icon" />

              {formatDailyVolumeLimit(currentCostingVersion.max_average_daily_volume)} daily volume limit exceeded
            </div>
          }
        </Col>
        <Col sm={12} md={2}>
          {
            formatBinaryCapacityUnit(total_cost.average_daily_volume)
          }
        </Col>
      </Row>

      <Row className="highlighted">
        <Col sm={12} md={10}>
          Estimated annual volume
        </Col>
        <Col sm={12} md={2}>
          {
            formatBinaryCapacityUnit(total_cost.yearly_volume)
          }
        </Col>
      </Row>
    </Fragment>
  )
}

export default VolumeSummary;
